module.exports = __webpack_public_path__ + "img/firing_1200x800.61f03a7a.svg";